import { useEffect, useState } from 'react'
import { useEoValue } from '~/src/hooks/useEoState'
import { CUSTOMER_STATE } from '~/src/stores/customer'
import { Customer } from '@eo-storefronts/eo-core'

type ReturnType = {
  isRequired: boolean,
  isShown: boolean,
}

const useCustomerProfilePasswordFieldState = (): ReturnType => {
  const customer = useEoValue<Customer | null>(CUSTOMER_STATE)
  const [ isRequired, setIsRequired ] = useState<boolean>(false)
  const [ isShown, setIsShown ] = useState<boolean>(false)

  useEffect(() => {
    if (!customer) {
      setIsRequired(false)
      setIsShown(false)

      return
    }

    const connectWith3rdParty: boolean = customer?.lastProvider === 'APPLE' || customer?.lastProvider === 'GOOGLE'

    setIsRequired(!connectWith3rdParty)
    setIsShown(!connectWith3rdParty)
  }, [ customer ])

  return { isRequired, isShown }
}

export default useCustomerProfilePasswordFieldState
